import { AxiosResponse } from "axios";
import { apinewforms } from "./api";
import { FlowHistoryResponse } from "../@types/flow-history";

type FlowHistoryParams = {
  flow: string;
  page: number;
  actor_name?: string;
  created_at_after?: string;
  created_at_before?: string;
};

export const getFlowHistoryList = (
  params: FlowHistoryParams
): Promise<AxiosResponse<FlowHistoryResponse>> =>
  apinewforms.get(`/core/auditlog/`, {
    params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("gov_access_token")}`,
    },
  });
